export const ApprovalIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8536 8.29062C16.0783 8.45112 16.1303 8.7634 15.9698 8.9881L10.9174 16.0615L7.35355 12.4977C7.15829 12.3025 7.15829 11.9859 7.35355 11.7906C7.54882 11.5954 7.8654 11.5954 8.06066 11.7906L10.7898 14.5197L15.1561 8.40687C15.3166 8.18216 15.6288 8.13011 15.8536 8.29062Z"
        fill="#262E3D"
        fillOpacity="0.67"
      />
    </svg>
  );
};
